import script from "./MeasurementList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeasurementList.vue?vue&type=script&setup=true&lang=ts"

import "./MeasurementList.vue?vue&type=style&index=0&id=0761a900&lang=scss"

const __exports__ = script;

export default __exports__